{
  "version": "v4.0.0",
  "name": "GetToken",
  "bytecodeTemplate": "01010300000006{1}{2}0e0c{0}0104",
  "fieldsSig": {
    "names": [
      "token",
      "sender",
      "amount"
    ],
    "types": [
      "TestToken",
      "Address",
      "U256"
    ],
    "isMutable": [
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}